import React, { useContext } from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import logo from "../assets/logo.png";
import Typography from "@mui/material/Typography";
import circle from "../assets/Circle.svg";
import ex from "../assets/x.svg";
import square from "../assets/square.svg";
import triangle from "../assets/triangle.svg";
import { MyButtonYellow } from "../components/Button";
import { AppContext } from "../context/AppContext";
import { useNavigate } from "react-router-dom";

const WelcomeScreen = () => {
  // Context
  const { playAudio } = useContext(AppContext);

  // Navigate
  const navigate = useNavigate();

  return (
    <Container>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#fff",
            height: { xs: "200px", md: "205px" },
            width: { xs: "170px", md: "190px" },
            display: "flex",
            alignItems: "center",
            // justifyItems: "center",
            flexDirection: "column",
            position: "relative",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              mt: { xs: "3em", md: "4em" },
            }}
          >
            <img
              src={logo}
              alt="this is a logo"
              width="50%"
              height="auto"
            ></img>
          </Box>
          <Box
            sx={{
              position: "absolute",
              bottom: 0,
              display: "flex",
              justifyContent: "space-evenly",
              width: "100%",
            }}
          >
            <Box
              sx={{
                backgroundColor: "#591A68",
                width: "30px",
                height: "35px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src={circle} alt="this is a circle icon" width="50%"></img>
            </Box>
            <Box
              sx={{
                backgroundColor: "#591A68",
                width: "30px",
                height: "35px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src={ex} alt="this is a t-shaped icon" width="50%"></img>
            </Box>
            <Box
              sx={{
                backgroundColor: "#591A68",
                width: "30px",
                height: "35px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src={square} alt="this is a square icon" width="50%"></img>
            </Box>
            <Box
              sx={{
                backgroundColor: "#591A68",
                width: "30px",
                height: "35px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={triangle}
                alt="this is a triangle icon"
                width="50%"
              ></img>
            </Box>
          </Box>
        </Box>
        <Typography
          variant="h3"
          sx={{
            textAlign: "center",
            fontSize: { xs: "2rem", md: "3rem" },
            fontWeight: 900,
            textTransform: "uppercase",
            width: { xs: "70%", sm: "100%", md: "70%" },
            mt: { xs: "1.8em", sm: "2.5em", md: "1.1em" },
            lineHeight: 1.2,
            letterSpacing: "4px",
          }}
        >
          Welcome{" "}
          <span style={{ fontSize: "1.5rem", fontWeight: 700 }}>to the</span>{" "}
          National Training Seminar <br />
          Enugu 2023
        </Typography>
        <Typography
          sx={{
            fontWeight: 400,
            width: { xs: "95%", sm: "80%", md: "33%" },
            textAlign: "center",
            fontSize: { xs: "1rem", sm: "2rem", md: "1rem" },
            mt: "1em",
          }}
        >
          A training{" "}
          <span style={{ color: "#EDAD4D", fontWeight: 600 }}>contest</span>{" "}
          between the{" "}
          <span style={{ color: "#EDAD4D", fontWeight: 600 }}>
            districts in
          </span>{" "}
          our entity!!
        </Typography>
        <MyButtonYellow
          as={"a"}
          // href="/form"
          sx={{
            mt: { xs: "3em", md: "3em" },
            mb: { xs: "3em", md: "0em" },
            textDecoration: "none",
          }}
          onClick={() => {
            navigate("/form");
            playAudio();
          }}
        >
          <Box
            sx={{
              width: "10px",
              height: "10px",
              backgroundColor: "#591A68",
              marginRight: { xs: "30px", md: "30px" },
            }}
          ></Box>
          Get identified
          <Box
            sx={{
              width: "10px",
              height: "10px",
              backgroundColor: "#591A68",
              marginLeft: { xs: "30px", md: "30px" },
            }}
          ></Box>
        </MyButtonYellow>
      </Box>
    </Container>
  );
};

export default WelcomeScreen;
